import { useComputedColorScheme } from '@mantine/core';
import { type ReactNode, useMemo } from 'react';
import { appColorSchemeContext, type AppColorSchemeValue } from './appColorScheme.context';

export function AppColorSchemeProvider({ children }: { children: ReactNode }) {
  const colorScheme = useComputedColorScheme('light');

  const value = useMemo<AppColorSchemeValue>(
    () => ({
      colorScheme,
      isLightMode: colorScheme === 'light',
      isDarkMode: colorScheme === 'dark'
    }),
    [colorScheme]
  );

  return <appColorSchemeContext.Provider value={value}>{children}</appColorSchemeContext.Provider>;
}
